import React from "react";
import { ReducerAction } from "../../hooks/ReducerOnChange";
import { CampoNumero, Tipo, ValidationResult } from "../../components";
import { ContributionTypes, Messages } from "./Constants";
import { CDataEmploymentItem } from "../../form/DigitalProductAnalyser/PrimaryAnalyser";

interface IEmploymentFormProps {
    Data: CDataEmploymentItem[];
    EmploymentLength: any;
    OnChange: React.Dispatch<ReducerAction<CDataEmploymentItem[]>>;
}

export const EmploymentForm: React.FC<IEmploymentFormProps> = ({ Data, EmploymentLength, OnChange }) => {
    const getValidationMessage = (item: CDataEmploymentItem): string => {
        let message: string = "";
        const isPeriodSet: boolean = !!(item.Days || item.Weeks || item.Months || item.Years);

        if (item.ContributionType && !isPeriodSet) {
            message = Messages.IndicatePeriod;
        } else if (!item.ContributionType && isPeriodSet) {
            message = Messages.IndicateType;
        }

        return message;
    };

    const addEmploymentItem = () => {
        OnChange({
            Type: "Set",
            Value: [...Data, new CDataEmploymentItem()]
        });
    };

    const removeEmploymentItem = (index: number) => {
        Data.splice(index, 1);
        OnChange({
            Type: "Set",
            Value: [...Data]
        });
    };

    const validationMessages: string[] = Data.map((item: CDataEmploymentItem) => getValidationMessage(item));
    const isFormInValid: boolean = !!validationMessages.filter(item => item).length;

    return (
        <>
            <table className="table table-sm table-striped col-lg-5 offset-lg-1">
                <thead>
                    <tr>
                        <th></th>
                        <th>Anni</th>
                        <th>Mesi</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Anzianità di Servizio Totale</th>
                        <td>{EmploymentLength.total.years()}</td>
                        <td>{EmploymentLength.total.months()}</td>
                    </tr>
                    <tr>
                        <th scope="row">Anzianità di Servizio Corrente</th>
                        <td>{EmploymentLength.current.years()}</td>
                        <td>{EmploymentLength.current.months()}</td>
                    </tr>
                    <tr>
                        <th scope="row">Anzianità di Servizio di Ricongiunzione</th>
                        <td>{EmploymentLength.previous.years()}</td>
                        <td>{EmploymentLength.previous.months()}</td>
                    </tr>
                </tbody>
            </table>

            <div className="col-lg-12 kt--align-right remove-square-button">
                <button disabled={isFormInValid} type="button" className="btn btn-info square-button-with-icon" onClick={addEmploymentItem} title="Aggiungi">
                    <i className="fa fa-plus"></i>
                </button>
            </div>
            {Data.map((employmentItem, index) => (
                <div className={`form-group special-group kt-form login-form__group row${index !== Data.length - 1 ? " dashedborder" : ""}`} key={index}>
                    <div className="col-lg-3">
                        <label>Tipologia di Contribuzione</label>
                        <Tipo
                            Dati={ContributionTypes}
                            Campo="ContributionType"
                            ID_ChiaveString={employmentItem.ContributionType}
                            TradValori={false}
                            OnAggiorna={(e, v) => OnChange({ Type: "OnChangeFromValue", Name: `${index}.${e}`, Value: v })}
                            Richiesto={!!employmentItem.ContributionType}
                        />
                    </div>
                    <div className="col-lg-1">
                        <label>Giorni</label>
                        <div className="kt-input">
                            <CampoNumero
                                Id={`${index}.Days`}
                                Name={`${index}.Days`}
                                Valore={employmentItem.Days}
                                OnChange={(e, v) => OnChange({ Type: "OnChangeFromHybrid", NameEvent: Object.assign({}, e), Value: v })}
                                CSS="form-control kt-input"
                                Precisione={0}
                                Minimo={0}
                            />
                        </div>
                    </div>
                    <div className="col-lg-1">
                        <label>Settimane</label>
                        <div className="kt-input">
                            <CampoNumero
                                Id={`${index}.Weeks`}
                                Name={`${index}.Weeks`}
                                Valore={employmentItem.Weeks}
                                OnChange={(e, v) => OnChange({ Type: "OnChangeFromHybrid", NameEvent: Object.assign({}, e), Value: v })}
                                CSS="form-control kt-input"
                                Precisione={0}
                                Minimo={0}
                            />
                        </div>
                    </div>
                    <div className="col-lg-1">
                        <label>Mesi</label>
                        <div className="kt-input">
                            <CampoNumero
                                Id={`${index}.Months`}
                                Name={`${index}.Months`}
                                Valore={employmentItem.Months}
                                OnChange={(e, v) => OnChange({ Type: "OnChangeFromHybrid", NameEvent: Object.assign({}, e), Value: v })}
                                CSS="form-control kt-input"
                                Precisione={0}
                                Minimo={0}
                            />
                        </div>
                    </div>
                    <div className="col-lg-1">
                        <label>Anni</label>
                        <div className="kt-input">
                            <CampoNumero
                                Id={`${index}.Years`}
                                Name={`${index}.Years`}
                                Valore={employmentItem.Years}
                                OnChange={(e, v) => OnChange({ Type: "OnChangeFromHybrid", NameEvent: Object.assign({}, e), Value: v })}
                                CSS="form-control kt-input"
                                Precisione={0}
                                Minimo={0}
                            />
                        </div>
                    </div>
                    <div className="col-lg-2 TextCenter">
                        <label>Da Conteggiare</label>
                        <div className="kt-radio-inline inlinea">
                            <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                <input
                                    value="true"
                                    type="radio"
                                    id={`${index}.IsCounted`}
                                    name={`${index}.IsCounted`}
                                    checked={employmentItem.IsCounted}
                                    onChange={e => OnChange({ Type: "OnChangeFromValue", Name: e.currentTarget.name, Value: true })}
                                />
                                SI<span></span>
                            </label>
                            <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                <input
                                    value="false"
                                    type="radio"
                                    id={`${index}.IsCounted`}
                                    name={`${index}.IsCounted`}
                                    checked={!employmentItem.IsCounted}
                                    onChange={e => OnChange({ Type: "OnChangeFromValue", Name: e.currentTarget.name, Value: false })}
                                />
                                NO<span></span>
                            </label>
                        </div>
                    </div>
                    <ValidationResult Columns={2} Message={validationMessages[index]} />
                    <div className="col-lg-1 kt--align-right remove-square-button">
                        <button type="button" className="btn btn-danger square-button-with-icon" onClick={() => removeEmploymentItem(index)} title="Elimina">
                            <i className="fa fa-minus"></i>
                        </button>
                    </div>
                </div>
            ))}
        </>
    );
};



// WEBPACK FOOTER //
// ./src/components/DigitalProductAnalyser/EmploymentForm.tsx